/*
* Copyright (C) Regione Lombardia
*/
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { AnagraficaService } from '@shared/services/anagrafica.service';
import { OperaService } from '@shared/services/opera.service';
import { forkJoin, map, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PagesGestioneOperaModificaOperaResolver implements Resolve<Observable<any>> {

    constructor(
        private anagraficaService: AnagraficaService,
        private operaService: OperaService
    ) { }

    resolve(route: ActivatedRouteSnapshot): Observable<any> {
        return forkJoin([
            this.anagraficaService.getClasseDocumento(),
            this.anagraficaService.getComuni(),
          this.anagraficaService.getClassificazioneOpera(),
            this.anagraficaService.getEvento(),
            this.anagraficaService.getFascePercentuali(),
            this.anagraficaService.getFonte(),
            this.anagraficaService.getFunzionePrevalente(),
            this.anagraficaService.getImportanzaOpera(),
            this.anagraficaService.getLivelloDanno(),
            this.anagraficaService.getMacroTipologiaOpera(),
            this.anagraficaService.getMateriale(),
            // this.anagraficaService.getProvenienza(),
            this.anagraficaService.getProvince(),
            this.anagraficaService.getSponda(),
            this.anagraficaService.getStatoOpera(),
            this.anagraficaService.getTipologiaIntervento(),
            this.anagraficaService.getTipologiaOpera(),
            this.anagraficaService.getTipologiaRilevamento(),
            this.anagraficaService.getTipoShape(),
            this.operaService.documentoOperaByIdOpera(route.params['idOpera']),
            this.operaService.manutenzioneByIdOpera(route.params['idOpera']),
            this.operaService.monitoraggioByIdOpera(route.params['idOpera']),
            this.operaService.operaSecondariaByIdOpera(route.params['idOpera']),
            this.operaService.pianoInterventiByIdOpera(route.params['idOpera']),
            this.operaService.rilevamentoByIdOpera(route.params['idOpera']),
        ]).pipe(
            map(([
                responseAnagraficaClasseDocumento,
                responseAnagraficaComuni,
                responseAnagraficaClassificazioneOpera,
                responseAnagraficaEvento,
                responseAnagraficaFascePercentuali,
                responseAnagraficaFonte,
                responseAnagraficaFunzionePrevalente,
                responseAnagraficaImportanzaOpera,
                responseAnagraficaLivelloDanno,
                responseAnagraficaMacroTipologiaOpera,
                responseAnagraficaMateriale,
                // responseAnagraficaProvenienza,
                responseAnagraficaProvince,
                responseAnagraficaSponda,
                responseAnagraficaStatoOpera,
                responseAnagraficaTipologiaIntervento,
                responseAnagraficaTipologiaOpera,
                responseAnagraficaTipologiaRilevamento,
                responseAnagraficaTipoShape,
                responseDocumentoOperaByIdOpera,
                responseManutenzioneOperaByIdOpera,
                responseMonitoraggioOperaByIdOpera,
                responseOperaSecondariaByIdOpera,
                responsePianoInterventiByIdOpera,
                responseRilevamentoByIdOpera,
            ]) => {
                return {
                    documentoOpera: responseDocumentoOperaByIdOpera,
                    manutenzioneOpera: responseManutenzioneOperaByIdOpera,
                    monitoraggioOpera: responseMonitoraggioOperaByIdOpera,
                    operaSecondaria: responseOperaSecondariaByIdOpera,
                    pianoInterventi: responsePianoInterventiByIdOpera,
                    rilevamentoOpera: responseRilevamentoByIdOpera,
                    datalist: {
                        classeDocumento: responseAnagraficaClasseDocumento,
                       classificazioneOpera: responseAnagraficaClassificazioneOpera,
                        comuni: responseAnagraficaComuni,
                        evento: responseAnagraficaEvento,
                        fascePercentuali: responseAnagraficaFascePercentuali,
                        fonte: responseAnagraficaFonte,
                        funzionePrevalente: responseAnagraficaFunzionePrevalente,
                        importanzaOpera: responseAnagraficaImportanzaOpera,
                        livelloDanno: responseAnagraficaLivelloDanno,
                        macroTipologiaOpera: responseAnagraficaMacroTipologiaOpera,
                        materiale: responseAnagraficaMateriale,
                        // provenienza: responseAnagraficaProvenienza,
                        province: responseAnagraficaProvince,
                        sponda: responseAnagraficaSponda,
                        statoOpera: responseAnagraficaStatoOpera,
                        tipologiaIntervento: responseAnagraficaTipologiaIntervento,
                        tipologiaOpera: responseAnagraficaTipologiaOpera,
                        tipologiaRilevamento: responseAnagraficaTipologiaRilevamento,
                        tipoShape: responseAnagraficaTipoShape
                    }
                };
            })
        );
    }

}